import React from 'react';
export const CFIconTrendingDown = {
    alias: 'trending-down',
    defaultTitle: 'Trending Down',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M21 12a1 1 0 1 0-2 0v2.297l-4.24-4.948a.999.999 0 0 0-1.275-.206L9.22 11.702 4.77 6.36a1.002 1.002 0 0 0-1.54 1.28l5 6a1 1 0 0 0 1.284.217l4.275-2.565L17.826 16H15a1 1 0 1 0 0 2h5a.978.978 0 0 0 .364-.074c.05-.019.087-.051.132-.076.052-.031.108-.05.154-.091.01-.008.014-.02.023-.029.055-.05.093-.111.135-.172.033-.048.072-.09.095-.142.025-.053.033-.112.047-.169.02-.07.04-.138.042-.21.001-.013.008-.024.008-.037v-5Z' }))),
};
